import React from 'react';
import styled from 'styled-components';
import { useDataPresentationParam } from '@/hooks';
import { IconButton, TrevorComponent, TrevorIcon } from '@trevor/ui-components';
import { useLoadRows_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import { usePagination } from './usePagination';

const MAX_ROWS_PER_PAGE = 100;

const _Pagination: TrevorComponent = ({ className }) => {
  const [
    page,
    totalNumberOfPages,
    handlePaginateForward,
    handlePaginateBackward,
  ] = usePagination();
  const dataPresentation = useDataPresentationParam();
  const { rowCount } = useLoadRows_LEGACY();

  if (dataPresentation) return null;

  return (
    <div className={className}>
      {page > 1 && (
        <IconButton
          onClick={handlePaginateBackward}
          icon={<TrevorIcon name="arrow-left" />}
        />
      )}
      <span>
        Page {page} of {totalNumberOfPages}
      </span>
      {(page < totalNumberOfPages || rowCount === MAX_ROWS_PER_PAGE) && (
        <IconButton
          onClick={handlePaginateForward}
          icon={<TrevorIcon name="arrow-right" />}
        />
      )}
    </div>
  );
};

export const Pagination = styled(_Pagination)`
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  margin-left: auto;
`;
